<template>
  <section class="subscr-constructor_section">
    <div class="container default">
      <div class="section_content">

        <div class="subscr-constructor_form_block">
          <form class="subscr-constructor_form">
            <h2 class="title">Fill out the form below</h2>

            <form-inputs @input="updateResults" />
            <form-company-select @selected-company="updateSelectResult" />
          </form>
        </div>

        <div class="subscr-constructor_result_block">
          <result-block :inputValues="inputValues"
                        :selected-company="selectedCompany"
                        @resetInputValues="resetInputValues"
                         />
        </div>

      </div>
    </div>
  </section>
</template>

<script>
import FormInputs from './FormInputs'
import FormCompanySelect from "./FormCompanySelect.vue";
import ResultBlock from "./ResultBlock.vue";

export default {
  name: "SubscrConstructorSection",
  components: {
    FormInputs,
    FormCompanySelect,
    ResultBlock,
  },
  data() {
    return {
      inputValues: {
        name: '',
        position: '',
        email: '',
        phone: '',
      },
      selectedCompany: {}
    };
  },
  methods: {
    updateResults(inputValues) {
      this.inputValues = inputValues;
    },
    updateSelectResult(company) {
      this.selectedCompany = company;
    },
    resetInputValues() {
      for (const key in this.inputValues) {
        this.inputValues[key] = "";
      }
      this.selectedCompany.value = "";
      this.selectedCompany.logoUrl = "";
    },
  },
}
</script>

<style lang="scss" scoped>
/* variables */
$titles-color: #242930;

.subscr-constructor_section {
  padding: 100px 0 120px 0;
  .section_content {
    display: flex;
    width: 100%;
    & > * {
      width: calc(50% - 40px);
      margin-right: 80px;
      &:last-child {
        margin-right: 0;
      }
    }
  }

  @media only screen and (max-width: 880px) {
    .section_content {
      flex-direction: column;
      & > * {
        width: 100%;
        margin-right: 0;
        margin-bottom: 60px;
        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }

  @media only screen and (max-width: 640px) {
    padding: 32px 0 80px 0;
  }
}

/* subscr-constructor_form */
.subscr-constructor_form {
  .title {
    margin: 0 0 32px 0;
    line-height: 1.34;
    font-size: 24px;
    font-weight: bold;
    color: $titles-color;
  }
}

.subscr-constructor_result_block {
  .button {
    margin: 32px 0 0 0;
  }
}


</style>